module.exports = __webpack_public_path__ + "static/media/prescription-bottle-alt.7629d31b.svg";